import { render } from "./NewSearch.vue?vue&type=template&id=03d4bf25"
import script from "./NewSearch.vue?vue&type=script&lang=js"
export * from "./NewSearch.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__